exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card-footer[data-v-4fa51438]{text-align:right;font-size:14px;line-height:1.5}.flex-row-center[data-v-4fa51438]{display:flex;justify-content:center;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-4fa51438&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/SystemConfig/SystemConfig/Components/CreditScoreCampusShield.vue
// module id = 525
// module chunks = 0